import React from 'react';
import { Row } from 'react-table';
import { CountryFlag } from 'CountryFlag/CountryFlag';

import { Link } from 'react-router-dom';
import { Icon, VesselIcon } from 'app/components';
import { t } from 'i18next';
import { PortTargetEvent } from 'ais-facade-api/api';
import moment from 'moment';
import { PortTargetEventTypeEnum } from './PortEvents';
import styles from './PortDetails.module.scss';
import { useFormatMoment } from 'app/hooks/useFormatMoment';

export const portEventsCallsColumns = [
  {
    Header: <Icon name="s-ais" size="20px" color="#fff" />,
    accessor: 'type',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => {
      return (
        <div className={styles.center_icon_cell}>
          <VesselIcon vessel={vessel.targetData} />
        </div>
      );
    },
  },
  {
    Header: 'MMSI',
    accessor: 'mmsi',
    cellClassName: `${styles.link}`,
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) =>
      vessel.targetData && typeof vessel.targetData.mmsi === 'number' ? (
        <Link to={`/vessels/${vessel.targetData.mmsi}`} className={styles.link}>
          {vessel.targetData.mmsi}
        </Link>
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
  },
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>
        {typeof vessel?.targetData?.registryData?.name === 'string' ? (
          vessel.targetData.registryData.name
        ) : typeof vessel?.targetData?.staticData?.name === 'string' ? (
          vessel.targetData.staticData.name
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
  },
  {
    Header: 'IMO',
    accessor: 'imo',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>
        {typeof vessel?.targetData?.registryData?.imo === 'number' ? (
          vessel.targetData.registryData.imo
        ) : typeof vessel?.targetData?.staticData?.imo === 'number' ? (
          vessel.targetData.staticData.imo
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Flag',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>
        {vessel.targetData?.meta?.countryName ? (
          <>
            {vessel.targetData?.meta?.countryCode && (
              <CountryFlag countryCode={vessel.targetData?.meta?.countryCode?.toLocaleLowerCase()} />
            )}
            {vessel.targetData?.meta?.countryName} ({vessel.targetData?.meta?.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: <Icon name="catalog-fleet" size="16px" />,
    accessor: 'belongsToFleet',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>
        {vessel.targetData?.belongsToFleet ? (
          <div className={styles.center_icon_cell}>
            <Icon name="catalog-fleet" size="16px" />
          </div>
        ) : (
          <></>
        )}
      </>
    ),
  },
  {
    Header: 'Type',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>{vessel.targetData && vessel.targetData?.meta?.typeGroup ? vessel.targetData?.meta?.typeGroup : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'EventType',
    accessor: 'typeEvent',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => (
      <>
        {vessel.eventType === PortTargetEventTypeEnum.LowerTheAnchor ? (
          t('LowerTheAnchor')
        ) : vessel.eventType === PortTargetEventTypeEnum.RaiseTheAnchor ? (
          t('RaiseTheAnchor')
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'EventDate',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetEvent> }) => {
      const formatMoment = useFormatMoment();
      return <>{vessel.eventDateTime ? formatMoment(moment(vessel.eventDateTime)) : <>&mdash;</>}</>;
    },
    canSort: true,
    sortBy: 'EVENT_DATE_TIME',
  },
];
